import React from 'react'
import T from '../i18n/T'
import { resetSearchHistory } from '../../store/search/searchSlice'
import useEventCallback from '../utils/useEventCallback'
import s from './SuggestClearHistory.less'
import { isEmpty } from '../../utils/lang'
import { useDispatch } from 'react-redux'

const SuggestClearHistory = ({ suggestionsSearchHistory }) => {
  const dispatch = useDispatch()
  const hasSearchHistorySuggests = !isEmpty(suggestionsSearchHistory)

  const onSuggestCleanHistory = useEventCallback(() => {
    dispatch(resetSearchHistory())
  }, [])

  if (!hasSearchHistorySuggests) return <></>
  return (
    <div className={s.SuggestCleanHistory}>
      <span onClick={onSuggestCleanHistory}>
        <T id={'suggest.history.clear'} />
      </span>
    </div>
  )
}

export default SuggestClearHistory
